<template>
    <div class="btn-loading">
        <lottie-player src="../../../static/js/loading_white.json"  background="transparent"  speed="1" loop autoplay></lottie-player>
        <!-- https://lottiefiles.com/7774-loading#_=_ -->
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .btn-loading{
        position: absolute;
        width: 35px !important;
        height: 35px !important;
        z-index: 9;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/btnLoading.vue